module.exports = __webpack_public_path__ + "img/main-screen-right.486b7ccd.svg";